module.exports = __webpack_public_path__ + "img/key-solid.d04dfc48.svg";